module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/psg_one-c8e423c7be4cf5a72a332186230240c3.png";